import { PRIMARY_CURRENCY_DECIMALS } from 'constants/currencies'
import { useMarketPriceConfig } from 'store/market/hooks'
import { TradeType } from 'store/market/types'
import { OrderDirection, OrderModeNames } from 'store/spot/types'
import { Ether } from 'types'
import { calculateMarketPriceForStopMarket } from 'utils/calculateMarketPriceForStopMarket'
import { getPriceByModeName } from 'utils/getPriceByModeName'

// TODO: Implement useOrderPriceByMode
export function useOrderPriceByMode(
  modeName: OrderModeNames,
  limitPrice: Ether,
  marketPrice: Ether,
  stopPrice: Ether,
  tradeType: TradeType,
  direction: OrderDirection,
): Ether {
  const marketPriceConfig = useMarketPriceConfig()

  if (modeName === OrderModeNames.StopMarket) {
    return calculateMarketPriceForStopMarket(
      direction,
      stopPrice,
      tradeType,
      PRIMARY_CURRENCY_DECIMALS,
      marketPriceConfig,
    )
  } else if (modeName === OrderModeNames.Market) {
    return marketPrice
  } else {
    return limitPrice
  }
}
